/* eslint-disable no-param-reassign */

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  privacyDesc: null, // [{lang:'zh',privacy:'...'},{lang:'en',privacy:'...'}]
  termsOfServiceDesc: null, // [{lang:'zh',termsOfService:'...'},{lang:'en',termsOfService:'...'}]
};

const settingSlice = createSlice({
  name: "setting",
  initialState,
  reducers: {
    setPrivacyDesc: (state, action) => {
      state.privacyDesc = action.payload;
    },
    setTermsOfServiceDesc: (state, action) => {
      state.termsOfServiceDesc = action.payload;
    },
  },
});

export const { setPrivacyDesc, setTermsOfServiceDesc } = settingSlice.actions;

export default settingSlice.reducer;
